'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./validation.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Validation(_ref) {
  var validationMessageTemplate = _ref.validationMessageTemplate,
      validationMessage = _ref.validationMessage,
      state = _ref.state,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ['validationMessageTemplate', 'validationMessage', 'state', 'className']);

  var validationClasses = (0, _classnames2.default)('validation', state && 'validation--' + state, className);

  if (!validationMessage && !validationMessageTemplate) {
    return null;
  }

  if (validationMessageTemplate) {
    return _react2.default.createElement(
      'span',
      _extends({ className: validationClasses }, props),
      validationMessageTemplate()
    );
  }

  return _react2.default.createElement(
    'span',
    _extends({ className: validationClasses }, props),
    validationMessage
  );
}

Validation.propTypes = {
  validationMessage: _propTypes2.default.string,
  validationMessageTemplate: _propTypes2.default.func,
  state: _propTypes2.default.oneOf(['success', 'error', 'warning', 'hint']),
  className: _propTypes2.default.string
};

exports.default = Validation;